import React, { useState, useEffect } from "react";
import star from "../Images/star.png";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { MyDomain } from "../App";
import { useTranslation } from "react-i18next";
import { AppContext, useAppContext } from "../AppContext";

export default function Header1() {
  const { Lang, setLang } = useAppContext();

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const GetPromoCodes = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}PromoCodes/GetPromoCodes`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const history = useHistory();

  const [Choosing, setChoosing] = useState(lang);
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);

  const handleDivClick = (CategoryName) => {
    history.push(`/${CategoryName}`); // Navigate to the root path
  };
  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      <div
        style={{
          width: "100%",
          justifyContent: MyWidth <= 1024 ? "center" : "space-between",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <div
          style={{
            justifyContent: "center",
            flexDirection: "row",
            display: "flex",
          }}
        >
          <p
            style={{
              margin: 9,
              padding: 0,
              fontSize: 12,
              cursor: "pointer",
              color: hovered2 ? "blue" : "black", // Change color based on hover state
              fontFamily: "Droid Arabic Kufi, sans-serif",
            }}
            onClick={() => {
              handleDivClick("delivery");
            }}
            onMouseEnter={() => setHovered2(true)}
            onMouseLeave={() => setHovered2(false)}
          >
            {t("navigation.FreeDeliveryover")} 299
          </p>
        </div>
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
              }}
            >
              <p
                style={{
                  margin: 5,
                  padding: 0,
                  color: "red",
                  paddingLeft: 10,
                  paddingRight: 10,
                  fontSize: 12,
                  cursor: "pointer",
                  fontFamily: "Droid Arabic Kufi, sans-serif",
                }}
                onClick={() => {
                  handleDivClick("actions");
                }}
              >
                {t("navigation.Specialoffers")}
              </p>
              <p
                style={{
                  margin: 5,
                  padding: 0,
                  paddingLeft: 10,
                  paddingRight: 10,
                  fontSize: 12,
                  cursor: "pointer",
                  color: hovered ? "blue" : "black", // Change color based on hover state
                  fontFamily: "Droid Arabic Kufi, sans-serif",
                }}
                onClick={() => {
                  handleDivClick("delivery");
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              >
                {t("navigation.DeliveryandPayment")}
              </p>
              <p
                style={{
                  margin: 5,
                  padding: 0,
                  paddingLeft: 10,
                  paddingRight: 10,
                  fontSize: 12,
                  cursor: "pointer",
                  color: hovered1 ? "blue" : "black", // Change color based on hover state
                  fontFamily: "Droid Arabic Kufi, sans-serif",
                }}
                onClick={() => {
                  handleDivClick("about-us");
                }}
                onMouseEnter={() => setHovered1(true)}
                onMouseLeave={() => setHovered1(false)}
              >
                {t("navigation.Aboutus")}
              </p>
            </div>
            <div
              style={{
                justifyContent: "space-between",
                flexDirection: "row",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: 20,
                }}
              >
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 12,
                    color: Lang === "he" ? "black" : "#a1a1aa",
                    cursor: "pointer",
                    fontWeight: Lang === "he" ? "bold" : "",
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("he");
                    changeLanguage("he");
                    localStorage.setItem("lang", JSON.stringify("he"));
                  }}
                >
                  עברית
                </p>
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 12,
                    cursor: "pointer",
                    color: Lang === "ar" ? "black" : "#a1a1aa",
                    fontWeight: Lang === "ar" ? "bold" : "",
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("ar");
                    changeLanguage("ar");
                    localStorage.setItem("lang", JSON.stringify("ar"));
                  }}
                >
                  العربية
                </p>
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 12,
                    cursor: "pointer",
                    color: Lang === "en" ? "black" : "#a1a1aa",
                    fontWeight: Lang === "en" ? "bold" : "",
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("en");

                    changeLanguage("en");
                    localStorage.setItem("lang", JSON.stringify("en"));
                  }}
                >
                  English
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: i18n.resolvedLanguage === "en" ? 0 : 20,
                }}
              >
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 12,
                    cursor: "pointer",
                    color: hovered3 ? "#6366f1" : "black", // Change color based on hover state
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                  onMouseEnter={() => setHovered3(true)}
                  onMouseLeave={() => setHovered3(false)}
                  onClick={() => {
                    handleDivClick("beauty-club");
                  }}
                >
                  Beauty Club
                </p>
                <img
                  src={star}
                  alt="logo"
                  style={{
                    minWidth: "10px", // Adjust the size
                    height: "10px", // Adjust the size
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>

      <div
        style={{
          height: "0.1px",
          backgroundColor: "#f4f4f5",
          width: "100%",
        }}
      ></div>
    </div>
  );
}
